import ApplicationController from "./application_controller";
import { FetchRequest } from '@rails/request.js'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = ["list", "organizationselect", "peoplelist"]

  connect() {
    console.log("say hi to the organization controller!");
  }

  async changeOrganization(_e) {
    const orgId = this.organizationselectTarget.value;
    console.log("now load the people of " + orgId + " into " + this.peoplelistTarget);

    const request = new FetchRequest('get', `/organizations/${orgId}/people`)
    const response = await request.perform()
    if (response.ok) {
      const html = await response.text
      this.peoplelistTarget.innerHTML = html
    }
  }
  invite() {
    const orgId = this.organizationselectTarget.value;
    window.location.href = `/organizations/${orgId}/invite`
  }
  show() {
    const orgId = this.organizationselectTarget.value;
    window.location.href = `/organizations/${orgId}`
  }
}
